'use client'

import type { ReactNode } from 'react'

import { tw } from '@/lib/utils'

interface NativeProductSelectProps {
  value: string
  onValueChange: (value: string) => void
  ariaLabel: string
  className?: string
  children: ReactNode
  options: ReactNode
}

// Keep the rich selected value while letting the browser handle the menu,
// keyboard navigation, and touch picker without a dropdown runtime.
export const NativeProductSelect = ({
  value,
  onValueChange,
  ariaLabel,
  className,
  children,
  options,
}: NativeProductSelectProps) => (
  <span
    className={tw(
      'relative inline-flex has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-4 has-[:focus-visible]:outline-lapis',
      className
    )}
  >
    <span aria-hidden="true" className="pointer-events-none contents">
      {children}
    </span>
    <select
      aria-label={ariaLabel}
      data-tracking="ignore"
      value={value}
      onChange={(event) => onValueChange(event.currentTarget.value)}
      className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
    >
      {options}
    </select>
  </span>
)
